import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=3f431302&scoped=true&lang=pug"
import script from "./Controls.vue?vue&type=script&lang=ts"
export * from "./Controls.vue?vue&type=script&lang=ts"
import style0 from "./Controls.vue?vue&type=style&index=0&id=3f431302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f431302",
  null
  
)

export default component.exports